import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  TextField,
  MenuItem,
  Button,
  Box,
  Divider,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  getCheckInitiatedFormDataById,
  getResignationId,
  getStageUpdate,
  ktSubmit,
} from "../../../api/resignationCheckliistAssign";
import { getEmployees } from "../../../api/employee";
import { useDispatch, useSelector } from "react-redux";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
export default function KTInitiationForm({ latestStatus, locationemployeeId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [projectsArray, setProjectArray] = useState([]);
  const user = useSelector((state) => state.user);
  const [prefilledData, setPrefilledData] = useState([]);
  const [employeeData, setEmployeeData] = useState({
    empId: locationemployeeId,
    latestStatus: latestStatus,
  });
  const [formData, setFormData] = useState({
    resignation_id: "",
    employee_id: "",
    employee_name: "",
  });

  const [employeeList, setempList] = useState([]);
  useEffect(() => {
    if (latestStatus) {
      if (latestStatus === "RESIGNATION ACCEPTED") {
      } else {
        getFormDataById();
      }
    }
  }, [latestStatus]);
  useEffect(() => {
    getResisnationDataBYId();
    getEmployeeListDetail();
    if (employeeData.empId === "") {
      navigate("/resignation-request");
    }
  }, []);

  async function getResisnationDataBYId() {
    try {
      const { data } = await getResignationId(params.id, user.token);

      let projects = [];
      if (!data?.msg) {
        if (data.data) {
          data.data?.map((el) => {
            projects.push({
              project_id: el.project_id,
              project_name: el.project_name,
              kt_handover_to: "",
              kt_assign_date: "",
              kt_completion_date: "",
            });
          });

          setProjectArray([...projects]);
          setFormData({
            ...formData,
            resignation_id: params.id,
            employee_id: data.data[0]?.employee_id,
            employee_name: data.data[0].employee_name,
          });
          setProjectArray([...projects]);
          setFormData({
            ...formData,
            resignation_id: params.id,
            employee_id: data.data[0]?.employee_id,
            employee_name: data.data[0].employee_name,
          });
        }
      } else {
        dispatch(showAlert(data.msg));
        callManualAssignProject();
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  async function getEmployeeListDetail() {
    try {
      const { data } = await getEmployees(
        { limit: "", offset: "" },
        user.token
      );

      setempList([...data.data]);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function getFormDataById() {
    try {
      const { data } = await getCheckInitiatedFormDataById(
        employeeData.empId,
        user.token
      );
      // setPrefilledData(data.data);
      let projects = [];
      if (!data?.msg) {
        if (data.data) {
          data.data?.map((el) => {
            projects.push({
              project_id: el.project_id,
              project_name: el.project_name,
              kt_handover_to: el.handover_to,
              kt_assign_date: el.assign_date,
              kt_completion_date: el.completion_date,
            });
          });

          setProjectArray([...projects]);
        }
      } else {
        dispatch(showAlert(data.msg));
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const onFormChange = (event, index) => {
    const { name, value } = event.target;
    if (name === "kt_handover_to") {
      projectsArray?.map((el) => {
        projectsArray[index].kt_handover_to = value;
      });
    }
    if (name === "kt_assign_date") {
      projectsArray?.map((el) => {
        projectsArray[index].kt_assign_date = value;
      });
    }
    if (name === "kt_completion_date") {
      projectsArray?.map((el) => {
        projectsArray[index].kt_completion_date = value;
      });
    }
    setProjectArray([...projectsArray]);
  };
  const onSubmit = async (event) => {
    event.preventDefault();
    let FormData = {
      ...formData,
      data: projectsArray,
    };
    try {
      const { data } = await ktSubmit(FormData, user.token);

      dispatch(showAlert(data.msg));
      navigate("/resignation-request");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  async function callManualAssignProject() {
    try {
      const { data } = await getStageUpdate(
        { id: params.id, update: "kt" },
        user.token
      );
      navigate("/resignation-request");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={8} md={3} pb={2}>
          <TextField
            fullWidth
            label="KT initiated for"
            value={formData.employee_name}
            disabled
          />
        </Grid>
      </Grid>

      {projectsArray?.map((project, index) => (
        <Box
          key={index}
          sx={{
            border: 2,
            borderColor: "primary.main",
            borderRadius: 5,
            p: 2,
            mb: 2,
            mt: 3,
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h8"
              style={{ fontWeight: "bold", color: "#08459c" }}
            >
              Project Name: {project.project_name}
            </Typography>
          </Box>

          <Grid container spacing={2} alignItems="center">
            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                disabled
                label="Project Name"
                defaultValue={project.project_name}
              />
            </Grid> */}
            <Grid item xs={4}>
              {latestStatus === "RESIGNATION ACCEPTED" ? (
                <TextField
                  fullWidth
                  name="kt_handover_to"
                  onChange={(event) => onFormChange(event, index)}
                  select
                  label="KT handover to"
                >
                  {/* Replace with your list of employees */}
                  {employeeList?.map((el, i) => {
                    // console.log(el,"cjs")
                    return (
                      <MenuItem
                        key={i}
                        value={el.firstname + " " + el.lastname}
                      >
                        {el.firstname + " " + el.lastname}
                      </MenuItem>
                    );
                  })}
                </TextField>
              ) : (
                <TextField
                  disabled
                  fullWidth
                  value={project.kt_handover_to}
                  label="KT handover to"
                />
              )}
            </Grid>
            <Grid item xs={4}>
              {latestStatus === "RESIGNATION ACCEPTED" ? (
                <TextField
                  name="kt_assign_date"
                  onChange={(event) => onFormChange(event, index)}
                  fullWidth
                  label="KT Assigned Date"
                  type="date"
                />
              ) : (
                <TextField
                  disabled
                  value={formatDateToYYYYMMDD(project.kt_assign_date)}
                  fullWidth
                  label="KT Assigned Date"
                  type="date"
                />
              )}
            </Grid>
            <Grid item xs={4}>
              {latestStatus === "RESIGNATION ACCEPTED" ? (
                <TextField
                  name="kt_completion_date"
                  onChange={(event) => onFormChange(event, index)}
                  fullWidth
                  label="KT Completion Date"
                  type="date"
                />
              ) : (
                <TextField
                  disabled
                  value={formatDateToYYYYMMDD(project.kt_completion_date)}
                  fullWidth
                  label="KT Completion Date"
                  type="date"
                />
              )}
            </Grid>
          </Grid>
        </Box>
      ))}
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            columnGap: 1,
            ml: "auto",
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              navigate(-2);
            }}
            className="blue-button"
          >
            CANCEL
          </Button>
          {latestStatus === "RESIGNATION ACCEPTED" &&
            projectsArray.length !== 0 && (
              <Button
                variant="contained"
                // onClick={handleSubmit(onLeaveUpdate)}
                onClick={onSubmit}
                type="button"
                style={{ padding: "5px 7px" }}
                className="blue-button"
              >
                SUBMIT
              </Button>
            )}
        </Box>
      </Grid>
    </Paper>
  );
}
function formatDateToYYYYMMDD(isoDateString) {
  if (!isoDateString) return ""; // Return empty string if input is falsy

  const datePortion = isoDateString.split("T")[0];
  return datePortion;
}
